import styled from 'styled-components';

const NotFoundWrapper = styled.div`
    
`;

export { NotFoundWrapper };
